import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { useAppSelector } from '../../../../redux/store';
import { ALL_THEME_BACKGROUND_PROPERTIES } from '../../../../types/themeBackgroundTypes';
import { DEFAULT_TABLE_SHADOW_ALPHA } from '../../../../types/themeTableTypes';
import { isTestEnvironment } from '../../../../utils/utils';
import { Rect } from '../../pixiComponents/rect';
export const SolidColorPokerTableDisplay = ({ tableAreaDimensions, feltDimensions, railDimensions }) => {
    const themeTableType = useAppSelector((state) => state.theme.themeTable?.type);
    const tableFeltColorNum = useAppSelector((state) => state.theme.themeTable?.tableFeltColorNum);
    const tableRailSolidColorNum = useAppSelector((state) => state.theme.themeTable?.tableRailSolidColorNum);
    const themeBackgroundType = useAppSelector((state) => state.theme.themeBackground?.type);
    if (!themeTableType ||
        !themeBackgroundType ||
        tableFeltColorNum === undefined ||
        tableRailSolidColorNum === undefined) {
        return null;
    }
    const feltX = tableAreaDimensions.w / 2 - feltDimensions.w / 2;
    const feltY = tableAreaDimensions.h / 2 - feltDimensions.h / 2;
    const feltWithRailX = tableAreaDimensions.w / 2 - railDimensions.w / 2;
    const feltWithRailY = tableAreaDimensions.h / 2 - railDimensions.h / 2;
    const dropShadowDistance = 10;
    const tableShadowAlpha = ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType].tableShadowAlpha !== undefined
        ? ALL_THEME_BACKGROUND_PROPERTIES[themeBackgroundType].tableShadowAlpha
        : DEFAULT_TABLE_SHADOW_ALPHA;
    const pixiData = isTestEnvironment()
        ? {
            type: 'theme-table',
            themeTableType
        }
        : null;
    return (_jsxs(Container, { "pixi-data": pixiData, interactiveChildren: false, children: [!!tableShadowAlpha && (_jsx(Rect, { x: feltWithRailX + dropShadowDistance, y: feltWithRailY + dropShadowDistance, w: railDimensions.w, h: railDimensions.h, fillColor: 0x000000, fillAlpha: tableShadowAlpha, radius: Math.min(railDimensions.w, railDimensions.h) / 2 })), _jsx(Rect, { x: feltWithRailX, y: feltWithRailY, w: railDimensions.w, h: railDimensions.h, fillColor: tableRailSolidColorNum, radius: Math.min(railDimensions.w, railDimensions.h) / 2 }), _jsx(Rect, { x: feltX, y: feltY, w: feltDimensions.w, h: feltDimensions.h, fillColor: tableFeltColorNum, radius: Math.min(feltDimensions.w, feltDimensions.h) / 2 })] }));
};
